require "../views/rate_settings_view"

class Extranet.Helpers.RateSettings

  @getRateSettingsView: () ->
    @rateSettingsView ?= new Extranet.Views.RateSettings
